import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SavedLists from './saved-lists-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SavedLists {...validProps} />;
}

SvgComponent.iconName = 'savedLists';

export const SavedListsIcon = svgIconWrapper(SvgComponent);
